import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Import glyph decorator for site-wide glyph functionality
import './utils/glyph-decorator';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import FaviconSetter from './components/FaviconSetter';
import PageTitleManager from './components/PageTitleManager';
import PasswordProtection from './components/PasswordProtection';
import PageTransition from './components/PageTransition';


// Ensure these imports correctly find and load your components as default exports
import Home from './pages/Home';
import Avatars from './pages/Avatars';
import Pricing from './pages/Pricing';
import HowItWorks from './pages/HowItWorks';
import Examples from './pages/Examples';
import Demo from './pages/Demo';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Glyph from './pages/Glyph';
import Glyph2Page from './pages/Glyph2.jsx';
import Gen from './pages/Gen';
import PatternSwap from './pages/PatternSwap';

function AppContent() {
  const location = useLocation();

  return (
    <>
      <FaviconSetter />
      <PageTitleManager />
      <Navigation />
      <PageTransition>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/avatars" element={<Avatars />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/examples" element={<Examples />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/glyph" element={<Glyph />} />
          <Route path="/glyph2" element={<Glyph2Page />} />
          <Route path="/gen" element={<Gen />} />
          <Route path="/pattern-swap" element={<PatternSwap />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </PageTransition>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <PasswordProtection>
      <Router>
        <AppContent />
      </Router>
    </PasswordProtection>
  );
}